const { registerBlockType } = wp.blocks;
// import "./style.scss";
import "./../../css/editor.scss";

import Edit from "./Edit";
// import Save from "./Save";

import metadata from "./../../../blocks/audioplaylist/block.json";

if (window.h5apPlayer?.isPipe) {
  registerBlockType(metadata, {
    edit: Edit,
    save: () => null,
    getEditWrapperProps: () => {
      return {
        className: "h5ap-playlist-block-wrapper h5ap-block-wrapper",
      };
    },
  });
}
